<template>
  <div class="landing">

    <div class="join-intro">
      <router-link to="/" class="top-logo">
        <img src="../assets/images/sift-logo.png" alt="Sift" class="sift-logo"/>
      </router-link>
      <h1>Choose Sift</h1>
<div class="choose-intro">
<p>
  Choose social media. Choose phone apps. Choose advertising. Choose low quality algorithm curated content. Choose notifications for stuff you aren’t interested in. Choose friend suggestions for people you’ve never heard of. Choose inspirational pictures. Choose having your private data sold to companies you hate. Choose bots trying to pretend to be people. Choose wading through screens of garbage just trying to find out how your mates are going.
</p>
<p>
  Or don’t.
</p>
</div>

<hr/>
<div class="choose-free-wrapper">
  <div class="col">
    <h2>Choose Sift.Life</h2>

    <p class="join-pull-quote">Sift is an online community where people get together &amp; talk crap on the internet. It has grown out of a love of mountain biking &amp; the outdoors but everyone is welcome - as long as they aren’t a complete knobend.</p>

  </div>
  <div class="col">
    <h2>Sift is Advertiser Free</h2>
    <p>
      Websites cost money to build &amp; run. We think charging our members directly is a lot more honest &amp; healthy than selling their souls to advertisers. This also means we can build Sift for its community, rather than for advertisers.
    </p>

  </div>
</div>
<hr/>

    </div>
    <div class="plans">
      <div v-for="plan in plans" class="plan">
        <div class="plan-title">{{ plan.title }}</div>
        <div class="plan-tagline">
          {{ plan.tagline }}
        </div>
        <div class="plan-price">
          {{ plan.price }}
        </div>
          <a :href="plan.url" class="plan-join button">
            Sign Up
          </a>
      </div>
    </div>
    <div class="back-wrapper">
      <router-link to="/" class="button back-button">Back</router-link>
      <p>

      </p>
      <a href="https://sift.life/login" class="button">Login</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SiftLanding',
  data () {
    return {
      plans: [
        {'title': '3 months',
        'tagline': 'Vaguely Committed',
        'price': 'USD$10.00',
        'url': 'https://sift.life/memberships/l/5095'},
        {'title': '6 months',
        'tagline': 'Somewhat Committed',
        'price': 'USD$20.00',
        'url': 'https://sift.life/memberships/l/4815'},
        {'title': '12 months',
        'tagline': 'Committed',
        'price': 'USD$36.00',
        'url': 'https://sift.life/memberships/l/4014'},
        {'title': 'Lifetime',
        'tagline': 'Very Committed',
        'price': 'USD$69.00',
        'url': 'https://sift.life/memberships/l/2271'}
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/SiftJoin.vue